var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysioThereapyBackgroung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19918_32913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19918_32913)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19918_32913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.217 82.6074H260.885V106.86C260.885 108.042 261.854 109 263.052 109H300.067C301.264 109 302.233 108.042 302.233 106.86V82.6074H302.902C304.1 82.6074 305.069 81.6492 305.069 80.4674C305.069 78.0494 304.222 75.8414 302.847 74.0474H307.185L320.285 98.1944C321.618 100.656 324.756 102.512 327.583 102.512C329.445 102.512 331.146 101.581 332.132 100.022C333.118 98.463 333.218 96.5456 332.401 94.8926L317.433 64.6023C315.934 61.5648 312.754 59.6024 309.33 59.6024H296.402V42.8387H318.395C322.028 42.8387 324.985 39.9192 324.985 36.3299C324.985 32.7406 322.028 29.82 318.395 29.82H278.039C273.259 29.82 269.372 33.6601 269.372 38.3802V62.8124C269.372 65.4512 270.337 67.8482 271.884 69.7674H268.884C262.91 69.7674 258.05 74.5678 258.05 80.4674C258.05 81.6492 259.019 82.6074 260.217 82.6074ZM297.9 104.72H265.219V82.6074H297.9V104.72ZM273.706 62.8124V38.3802C273.706 36.0196 275.65 34.1002 278.039 34.1002H318.395C319.64 34.1002 320.651 35.0999 320.651 36.3299C320.651 37.5588 319.64 38.5587 318.395 38.5587H294.235C293.037 38.5587 292.068 39.5169 292.068 40.6987V61.7424C292.068 62.9242 293.037 63.8824 294.235 63.8824H309.33C311.108 63.8824 312.761 64.9012 313.539 66.478L328.508 96.7704C328.726 97.2114 328.569 97.577 328.457 97.7547C328.343 97.9332 328.08 98.2322 327.583 98.2322C326.368 98.2322 324.68 97.2321 324.106 96.1746L310.393 70.8969C310.014 70.2011 309.28 69.7674 308.482 69.7674H294.235H280.748C276.865 69.7674 273.706 66.6473 273.706 62.8124ZM268.884 74.0474H280.748H294.235C297.06 74.0474 299.47 75.8362 300.365 78.3274H300.067H263.052H262.754C263.649 75.8362 266.059 74.0474 268.884 74.0474ZM285.623 26.9674C292.593 26.9674 298.262 21.3677 298.262 14.4837C298.262 7.59981 292.593 2 285.623 2C278.653 2 272.982 7.59981 272.982 14.4837C272.982 21.3677 278.653 26.9674 285.623 26.9674ZM285.623 6.28C290.202 6.28 293.928 9.96018 293.928 14.4837C293.928 19.0071 290.202 22.6874 285.623 22.6874C281.042 22.6874 277.316 19.0071 277.316 14.4837C277.316 9.96018 281.042 6.28 285.623 6.28Z",
    fill: "#B53657",
    stroke: "#B53657",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.688 58.6562C301.874 63.8429 304.782 66.7508 309.969 71.9375M312.625 53.3438L320.594 61.3125",
    stroke: "#F26B8A",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 85,
    cy: 102,
    r: 102,
    fill: "#F26B8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19918_32913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white",
    transform: "translate(242 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysioThereapyBackgroung);
export default __webpack_public_path__ + "static/media/PhysioThereapyBackgroung.38729dd9cccb5bc0817ef1a70cccae6f.svg";
export { ForwardRef as ReactComponent };